import { EInvoiceAddressSchemeType } from '@components'

import { TFunction } from 'i18next'

export const getEInvoicingAddressFieldErrorMessage = (
  t: TFunction,
  scheme: EInvoiceAddressSchemeType | undefined,
): string => {
  if (scheme === EInvoiceAddressSchemeType.SIRENE) {
    return t('external_invoices.send_as_e_invoice.modal.field.e_invoicing_address.SIRENE.error.invalid_format')
  }

  return t('external_invoices.send_as_e_invoice.modal.field.e_invoicing_address.error.invalid_format', {
    idType: scheme,
  })
}
